<template>
  <CModal
      :centered="true"
      :show.sync="editQBankModal"
      size="md"
      title="ویرایش بانک سوال"
  >
    <CForm class="edit-qbank-modal text-right">
      <CInput v-model="form.title" class="text-sm mt-3" label="عنوان"/>
      <div class="t-mt-3">درس</div>
      <div class="checkboxes">
        <CInputCheckbox
            v-for="course in courseList"
            :key="course.id"
            :checked="form.courseIds.includes(course.id)"
            :label="`${course.name} ${course.klass.grade.name} ${course.klass.name}`"
            :value="course.id"
            class="text-sm flex-fill pt-2"
            custom
            @update:checked="addCourseIds(course.id, $event)"
        />
      </div>
      <CTextarea v-model="form.text" class="text-sm mt-3" label="توضیحات"/>
      <div class="text-sm">ارسال فایل</div>
      <UploadFile
          v-if="editQBankModal === true"
          v-model="form.files"
          cat="QB"
          @upload-file="onUploadFile"
      />
    </CForm>

    <template #footer>
      <CButton class="px-5" color="primary" @click="onEditQBank"> ثبت</CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadFile from "../../UploadFile/UploadFile.vue";

export default {
  components: {UploadFile},
  props: {
    value: {
      type: Boolean,
    },
    qbank: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        courseIds: [],
        files: [],
      },
      loading: false,
      courseList: [],
    };
  },
  computed: {
    editQBankModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    editQBankModal(val) {
      if (val) {
        this.getCourses();
      }
      this.qbank.courses.map((item) => this.form.courseIds.push(item.id));
      this.form = {
        courseIds: this.form.courseIds,
        title: this.qbank.title,
        text: this.qbank.text,
        files: this.qbank.files,
      };
    },
  },
  methods: {
    async onEditQBank() {
      try {
        this.loading = true;
        const payload = {
          courseIds: this.form.courseIds,
          title: this.form.title,
          text: this.form.text,
          files: this.form.files,
        };
        await axios.put(`/qbank/${this.qbank.id}`, payload).then((response) => {
          if (response.status === 200) {
            this.editQBankModal = false;
            this.$emit("get-qbank");
          }
        });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },

    async getCourses() {
      try {
        this.loading = true;
        const {data} = await axios.get("/course");
        this.courseList = data;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    addCourseIds(item, event) {
      if (event === true) this.form.courseIds.push(item);
      const index = this.form.courseIds.findIndex((val) => val === item);
      if (event === false) this.form.courseIds.splice(index, 1);
    },
    onUploadFile(file) {
      this.form.files = [...new Set(this.form.files.concat(file))]
    },
  },
};
</script>

<style lang="scss" scoped>
.checkboxes {
  column-count: 2;
  column-gap: 10px;
}
</style>